'use strict';

/* global $ */

import { Ajax } from 'utils/ajax';

function Menu(options) {

    let opt = $.extend({
        burger: options.selector+'__burger',
        arrow: options.selector+'__arrow',
        city_current: options.selector+'__city-current',
        city_search: options.selector+'__city-search',
        city_submit: options.selector+'__city-submit',
        city_item: options.selector+'__city-item',
        submenu: options.selector+'__submenu',
        search: options.selector+'__search',
        search_block: options.selector+'__search-block',
        search_close: options.selector+'__search-close',
    }, options);

    function initBlock(el) {
        console.log('[ Menu/Init ]');
        let $el = $(el);
        $el.find(opt.burger).on('click', function(e) {
            e.preventDefault();
            console.log('[ Menu/Toggle ]');
            $el.toggleClass('is-open');
            //$('body').addClass('m--popup');
        });
        $el.find(opt.arrow).on('click', function(e) {
            e.preventDefault();
            console.log('[ Menu/Toggle submenu ]');
            $(this).toggleClass('m--up');
            $(this).siblings(opt.submenu).toggleClass('is-open');
        });
        $el.find(opt.search).on('click', function(e) {
            e.preventDefault();
            console.log('[ Menu/Toggle search ]');
            $(this).siblings(opt.search_block).toggleClass('is-open');
        });
        $el.find(opt.search_close).on('click', function(e) {
            e.preventDefault();
            console.log('[ Menu/Toggle search ]');
            $(this).parents(opt.search_block).toggleClass('is-open');
        });

        $el.find(opt.city_search).on('input', function() {
            console.log('[ Menu/Change city search string ]');
            let str = $(this).val();
            console.log(str, str.length);
            if (str.length > 1) {
                $el.find(opt.city_item).addClass('is-hidden');
                $el.find(opt.city_item).filter(function() {
                    return !$(this).data('city_name') || $(this).data('city_name').toLowerCase().indexOf(str.toLowerCase()) !== -1; // && $(this).data('area').toLowerCase().indexOf(str.toLowerCase()) === -1;
                }).removeClass('is-hidden');
            } else {
                $el.find(opt.city_item).removeClass('is-hidden');
            }
        });


        $el.find(opt.city_item).on('click', function(e) {
            e.preventDefault();
            console.log('[ Menu/Toggle city ]');
            let city_id = $(this).data('city_id');
            if (+city_id == -1) {
                $(this).parents().find(opt.city_item).removeClass('is-active');
                if (!$(this).hasClass('is-active')) {
                    $(this).addClass('is-active');
                }
            } else {
                $(this).toggleClass('is-active');
                if ($(this).parents().find(opt.city_item+'.is-active').length == 0) {
                    $(this).parents().find(opt.city_item+'[data-city_id=-1]').addClass('is-active');
                } else {
                    $(this).parents().find(opt.city_item+'[data-city_id=-1]').removeClass('is-active');
                }
            }

            $el.find(opt.city_current).addClass('is-hidden');
            $el.find(opt.city_submit).removeClass('is-hidden');
        });
        $el.find(opt.city_submit).on('click', function(e) {
            e.preventDefault();
            console.log('[ Menu/Submit city list ]');
            console.log($el.find(opt.city_item+'.is-active'));
            let cities = $el.find(opt.city_item+'.is-active').toArray().map(item => {
                return $(item).data('city_id');
            });
            console.log(cities);
            Ajax.get('set_cities', { cities: cities }).then((data) => {
                if (data.ok) {
                    location.reload();
                } else {
                    console.error('Can\'t change cities');
                }
            }).catch(function(error) {
                throw new Error(error);
            });
        });
    }

    $(opt.selector).each(function() {
        initBlock(this);
    });
}

export {
    Menu
};
